(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.documentElement.classList.add('titb-js-ready');

  const hero = document.querySelector('.titb-video-hero');
  const header = document.querySelector('.section-header');

  if (header) {
    const updateHeaderTone = () => {
      const headerHeight = header.offsetHeight || 0;
      const shouldOverlayHero = Boolean(hero) && window.scrollY <= Math.max(24, headerHeight * 0.8);
      document.body.classList.toggle('titb-header-over-hero', shouldOverlayHero);
    };

    updateHeaderTone();
    window.addEventListener('scroll', updateHeaderTone, { passive: true });
    window.addEventListener('resize', updateHeaderTone);
  }

  document.querySelectorAll('[data-titb-scroll-next]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const section = link.closest('.shopify-section');
      const nextSection = section ? section.nextElementSibling : null;

      if (!nextSection) return;

      event.preventDefault();
      nextSection.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    });
  });

  if (!reduceMotion) {
    window.addEventListener('pageshow', () => {
      document.body.classList.remove('titb-is-leaving');
    });

    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]');

      if (
        !link ||
        event.defaultPrevented ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey ||
        link.target ||
        link.hasAttribute('download')
      ) {
        return;
      }

      const url = new URL(link.href, window.location.href);
      const current = new URL(window.location.href);

      if (url.origin !== current.origin || url.pathname === current.pathname && url.hash) {
        return;
      }

      document.body.classList.add('titb-is-leaving');
    });
  }

  const revealItems = document.querySelectorAll('[data-titb-reveal]');

  if (revealItems.length && 'IntersectionObserver' in window && !reduceMotion) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('titb-is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.12 }
    );

    revealItems.forEach((item) => observer.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('titb-is-visible'));
  }

  const infiniteGrids = document.querySelectorAll('[data-titb-infinite-scroll]');

  infiniteGrids.forEach((container) => {
    if (!('IntersectionObserver' in window)) return;

    const sentinel = container.querySelector('[data-titb-infinite-sentinel]');
    if (!sentinel) return;

    let loading = false;

    const loadMore = async () => {
      const target = container.querySelector('a.pagination__item--prev, a[rel="next"]');

      if (!target || loading) return;

      loading = true;
      sentinel.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(target.href, { credentials: 'same-origin' });
        const html = await response.text();
        const nextDocument = new DOMParser().parseFromString(html, 'text/html');
        const nextGrid = nextDocument.querySelector('#product-grid');
        const currentGrid = container.querySelector('#product-grid');
        const nextPagination = nextDocument.querySelector('.pagination-wrapper');
        const currentPagination = container.querySelector('.pagination-wrapper');

        if (nextGrid && currentGrid) {
          nextGrid.querySelectorAll(':scope > li').forEach((item) => {
            item.setAttribute('data-titb-reveal', '');
            currentGrid.appendChild(item);
          });
        }

        if (currentPagination) {
          if (nextPagination) {
            currentPagination.replaceWith(nextPagination);
          } else {
            currentPagination.remove();
            sentinel.remove();
          }
        }
      } catch (error) {
        console.warn('TITB infinite scroll failed', error);
      } finally {
        loading = false;
        sentinel.removeAttribute('aria-busy');
      }
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) loadMore();
        });
      },
      { rootMargin: '700px 0px', threshold: 0 }
    );

    observer.observe(sentinel);
  });

  const drPopup = document.querySelector('[data-titb-dr-popup]');

  if (drPopup) {
    const popupKey = `titb-dr-popup-dismissed:${drPopup.dataset.countryCode || 'XX'}:${drPopup.dataset.productHandle || 'product'}`;
    const closePopup = () => {
      drPopup.hidden = true;
      document.body.classList.remove('titb-modal-open');
      sessionStorage.setItem(popupKey, '1');
    };

    if (sessionStorage.getItem(popupKey) !== '1') {
      drPopup.hidden = false;
      document.body.classList.add('titb-modal-open');
    }

    drPopup.querySelectorAll('[data-titb-dr-popup-close]').forEach((button) => {
      button.addEventListener('click', closePopup);
    });

    document.addEventListener('keydown', (event) => {
      if (!drPopup.hidden && event.key === 'Escape') closePopup();
    });
  }
})();
